// extracted by mini-css-extract-plugin
export default {"fake-checkbox":"FakeCheckbox_fake-checkbox__6npLA","icon-wrapper":"FakeCheckbox_icon-wrapper__Gmxwl"};